import React from 'react';
import LandlordIntegration from '../../invoice/landlord-integration';

export default function CustomizedPMS({ t, landlord = {}, getLandlord, updateLandlord }) {
  return (
    <div className="customized-pms">
      <p className="title">{t('cms.landlord.detail.token.customized_pms_integration')}</p>
      <LandlordIntegration
        landlord={landlord}
        getLandlord={getLandlord}
        updateLandlord={updateLandlord}
      />
    </div>
  );
}
